let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e3Wja")).then(() => parcelRequire('4qQ9E'));